/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DeactivatePrescriptionRequestBody,
  DeactivatePrescriptionRequestBody$Outbound,
  DeactivatePrescriptionRequestBody$outboundSchema,
} from "../components/deactivateprescriptionrequestbody.js";

export type PlatformKillswitchesNumberDeactivatePrescriptionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type PlatformKillswitchesNumberDeactivatePrescriptionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  deactivatePrescriptionRequestBody: DeactivatePrescriptionRequestBody;
};

/** @internal */
export type PlatformKillswitchesNumberDeactivatePrescriptionSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
  };

/** @internal */
export const PlatformKillswitchesNumberDeactivatePrescriptionSecurity$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberDeactivatePrescriptionSecurity$Outbound,
    PlatformKillswitchesNumberDeactivatePrescriptionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberDeactivatePrescriptionSecurityToJSON(
  platformKillswitchesNumberDeactivatePrescriptionSecurity:
    PlatformKillswitchesNumberDeactivatePrescriptionSecurity,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberDeactivatePrescriptionSecurity$outboundSchema
      .parse(platformKillswitchesNumberDeactivatePrescriptionSecurity),
  );
}

/** @internal */
export type PlatformKillswitchesNumberDeactivatePrescriptionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DeactivatePrescriptionRequestBody: DeactivatePrescriptionRequestBody$Outbound;
};

/** @internal */
export const PlatformKillswitchesNumberDeactivatePrescriptionRequest$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberDeactivatePrescriptionRequest$Outbound,
    PlatformKillswitchesNumberDeactivatePrescriptionRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      deactivatePrescriptionRequestBody:
        DeactivatePrescriptionRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        deactivatePrescriptionRequestBody: "DeactivatePrescriptionRequestBody",
      });
    }),
  );

export function platformKillswitchesNumberDeactivatePrescriptionRequestToJSON(
  platformKillswitchesNumberDeactivatePrescriptionRequest:
    PlatformKillswitchesNumberDeactivatePrescriptionRequest,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberDeactivatePrescriptionRequest$outboundSchema
      .parse(platformKillswitchesNumberDeactivatePrescriptionRequest),
  );
}
